export *                        from './power-info.component';

export { PowerCommon as Power } from '@Common/Elements/Devices';